/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.sd = {};
  Blockly.Language || (Blockly.Language = {});
  /**************************************************************************************************************/
  function setupSD() {
    // Push the librarie for the compiler
    Blockly.Arduino.includes_.push(libraries.sd);
    // Definitions for the SD card
    Blockly.Arduino.definitions_.define_sd = "#include <SD.h>\n";
    Blockly.Arduino.definitions_.var_sdfile ||
      (Blockly.Arduino.definitions_.var_sdfile = "File sd_file;\n");
    Blockly.Arduino.setups_.setup_sd || (Blockly.Arduino.setups_.setup_sd = "  SD.begin(4);\n");
  }
  /**************************************************************************************************************/
  Blockly.Arduino.sd_init = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    var chip_select_pin = this.getFieldValue("CS");
    Blockly.Arduino.setups_.setup_sd =
      "  // Chip select pin for SD card\n" +
      "  SD.begin(" + chip_select_pin + ");\n";
    return "";
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_print = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    const file = Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''";
    const string = Blockly.Arduino.valueToCode(this, "STRINGOUTPUT", Blockly.Arduino.ORDER_ATOMIC) || "''";
    const new_line = this.getFieldValue("NEWLINE");
  
    Blockly.Arduino.definitions_fnc_.fnc_sd_print =
      "/**\n" +
      "* @description: Function for writing data in the SD\n" +
      "*/\n" +
      "void fnc_sd_print(String _f, String _t, boolean _nl) {\n" +
      "   sd_file = SD.open(_f, FILE_WRITE);\n" +
      "   if(sd_file) {\n" +
      "       if(_nl)\n" +
      "           sd_file.println(_t);\n" +
      "       else sd_file.print(_t);\n" +
      "           sd_file.close();\n" +
      "  }\n}\n";
  
    return (
      "fnc_sd_print(" +
      file +
      ", String(" +
      string +
      "), " +
      ("TRUE" == new_line ? "true" : "false") +
      ");\n"
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_filesize = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    var a = Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''";
    Blockly.Arduino.definitions_fnc_.fnc_sd_filesize =
      "unsigned long fnc_sd_filesize(String _f) {\n" +
      "  unsigned long s = 0;\n" +
      "  sd_file = SD.open(_f, FILE_READ);\n" +
      "  if(sd_file) {\n" +
      "    s = sd_file.size();\n" +
      "    sd_file.close();\n" +
      "  }\n" +
      "  return s;\n" +
      "}\n";
    return ["fnc_sd_filesize(" + a + ")", Blockly.Arduino.ORDER_ATOMIC];
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_readbyte = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    var a = Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''",
      b = Blockly.Arduino.valueToCode(this, "POS", Blockly.Arduino.ORDER_ATOMIC) || 0;
    Blockly.Arduino.definitions_fnc_.fnc_sd_readbyte =
      "int fnc_sd_readbyte(String _f, unsigned long _p) {\n" +
      "  int s = -1;\n" +
      "  sd_file = SD.open(_f, FILE_READ);\n" +
      "  if(sd_file) {\n" +
      "    if(sd_file.seek(_p)) {\n" +
      "      s = sd_file.peek();\n" +
      "    }\n" +
      "    sd_file.close();\n" +
      "  }\n" +
      "  return s;\n" +
      "}\n";
    return ["fnc_sd_readbyte(" + a + ", " + b + ")", Blockly.Arduino.ORDER_ATOMIC];
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_readloop = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    var a = Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''",
        b = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VAR"), Blockly.VARIABLE_CATEGORY_NAME),
        c = Blockly.Arduino.statementToCode(this, "DO");
    a = "int " + b + ";\nsd_file = SD.open(" + (a + ", FILE_READ);\nif(sd_file){\n");
    a += "  while(sd_file.available()){\n";
    a = a + ("    " + b + " = sd_file.read();\n") + (c + "\n");
    a += "  }\n";
    a += "  sd_file.close();\n";
    return (a += "}\n");
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_writebyte = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    var a = Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''",
      b = Blockly.Arduino.valueToCode(this, "BYTE", Blockly.Arduino.ORDER_ATOMIC) || 0;
    Blockly.Arduino.definitions_fnc_.fnc_sd_writebyte =
      "void fnc_sd_writebyte(String _f, int _v) {\n" +
      "  sd_file = SD.open(_f, FILE_WRITE);\n" +
      "  if(sd_file) {\n" +
      "    sd_file.write(_v);\n" +
      "    sd_file.close();\n" +
      "  }\n" +
      "}\n";
    return "fnc_sd_writebyte(" + a + ", " + b + ");\n";
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_remove = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    return (
      "SD.remove(" +
      (Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''") +
      ");\n"
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_exists = function() {
    // Checker if SdFat.h is used skip this block
    if (Blockly.Arduino.definitions_.define_sdfat_include != null) return "";

    setupSD();
    return [
      "SD.exists(" +
        (Blockly.Arduino.valueToCode(this, "FILE", Blockly.Arduino.ORDER_ATOMIC) || "''") +
        ")",
      Blockly.Arduino.ORDER_ATOMIC
    ];
  };
  /**************************************************************************************************************/
  Blockly.Arduino.sd_format = function() {
    //var mode = Blockly.Arduino.valueToCode(this, "MODE", Blockly.Arduino.ORDER_ATOMIC) || "'F'";
    const mode = this.getFieldValue("MODE") || "F";;
    var code = "";
    
    // Checker if sd.h is used skip format block
    if (Blockly.Arduino.definitions_.define_sd != null) return code;

    // Push the librarie for the compiler
    Blockly.Arduino.includes_.push(libraries.sd_fat);

    // Includes & Consts & Defines
    Blockly.Arduino.definitions_.define_sdfat_include = 
    '#include "SdFat.h"\n';
    Blockly.Arduino.definitions_.define_sdfat_consts = 
    'const uint32_t ERASE_SIZE = 262144L;\n' +
    'const uint8_t SD_CS_PIN = 4;\n';
    Blockly.Arduino.definitions_.define_sdfat_defines = 
    '#define SPI_CLOCK SD_SCK_MHZ(50)\n' +
    '#define SD_CONFIG SdSpiConfig(SD_CS_PIN, SHARED_SPI, SPI_CLOCK)\n';

    // Var definitions
    Blockly.Arduino.definitions_.var_sdfat_global  = 
    'uint32_t cardSectorCount = 0;\n' +
    'uint8_t  sectorBuffer[512];\n';
    Blockly.Arduino.definitions_.var_sdfat_objets  = 
    'SdCardFactory cardFactory;\n' +
    'SdCard* m_card = nullptr;\n';

    // Functions
    Blockly.Arduino.definitions_fnc_.fnc_sdfat_erase =
    'void fnc_sdfat_erase() {\n' +
    '  uint32_t firstBlock = 0;\n' +
    '  uint32_t lastBlock;\n' +
    '  uint16_t n = 0;\n' +
    '  do {\n' +
    '    lastBlock = firstBlock + ERASE_SIZE - 1;\n' +
    '    if (lastBlock >= cardSectorCount) {\n' +
    '      lastBlock = cardSectorCount - 1;\n' +
    '    }\n' +
    '    if (!m_card->erase(firstBlock, lastBlock)) {\n' +
    '      return;\n' +
    '    }\n' +
    '    if ((n++)%64 == 63) {\n' +
    '    }\n' +
    '    firstBlock += ERASE_SIZE;\n' +
    '  } while (firstBlock < cardSectorCount);\n' +
    '}\n';
    
    Blockly.Arduino.definitions_fnc_.fnc_sdfat_format =
    'void fnc_sdfat_format() {\n' +
    '  ExFatFormatter exFatFormatter;\n' +
    '  FatFormatter fatFormatter;\n' +
    '  bool rtn = cardSectorCount > 67108864 ?\n' +
    '    exFatFormatter.format(m_card, sectorBuffer, NULL) :\n' +
    '    fatFormatter.format(m_card, sectorBuffer, NULL);\n' +
    '}\n';
    
    Blockly.Arduino.definitions_fnc_.fnc_sdfat_format_erase =
    'void fnc_sdfat_format_erase(char mode) {\n' +
    '  m_card = cardFactory.newCard(SD_CONFIG);\n' +
    '  cardSectorCount = m_card->sectorCount();\n' +
    '  if (mode == \'E\' || mode == \'F\') {\n' +
    '    fnc_sdfat_erase();\n' +
    '  }\n' +
    '  if (mode == \'F\' || mode == \'Q\') {\n' +
    '    fnc_sdfat_format();\n' +
    '  }\n' +
    '}\n';

    // Setups
    Blockly.Arduino.setups_.setup_sdfat = 
    '  fnc_sdfat_format_erase(\'' + mode + '\');\n' +
    '  while (true) {};\n';

    // Loop
    return code;
  };
}